import React, {Component} from "react";
import tienda_nube_logo from '../../images/tienda_nube_logo_v4.png';
import tienda_nube_logo_off from '../../images/tienda_nube_logo_v4_off.png';
import tienda_nube_logo_colorfully from '../../images/tienda_nube_logo_v4_colorfully.png';

export class TiendaNubeLogo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isHovered: false
        };
    }

    getRenderVeryColoredVersion() {
        if(this.props.renderVeryColoredVersion)
            return this.props.renderVeryColoredVersion;
        return false;
    }

    getIsColoredOnHover() {
        if(this.props.isColoredOnHover)
            return this.props.isColoredOnHover;
        return false;
    }

    handleMouseEnter = () => {
        this.setState({ isHovered: true });
    }

    handleMouseLeave = () => {
        this.setState({ isHovered: false });
    }

    getHeight() {
        if(this.props.height)
            return this.props.height;
        return 30;
    }

    getWidth() {
        if(this.props.width)
            return this.props.width;
        return 30;
    }

    getHSpace() {
        if(this.props.hspace !== undefined)
            return this.props.hspace;
        return 10;
    }

    getVSpace() {
        if(this.props.vspace !== undefined)
            return this.props.vspace;
        return 10;
    }

    getImage() {
        if(this.getRenderVeryColoredVersion())
            return tienda_nube_logo_colorfully;
        return !this.getIsColoredOnHover() || this.state.isHovered ? tienda_nube_logo : tienda_nube_logo_off;
    }

    render() {
        return <img alt="Tiendanube" style={this.props.styles} src={this.getImage()} height={this.getHeight()} width={this.getWidth()} hspace={this.getHSpace()} vspace={this.getVSpace()}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
        />
    }
}

